import { render, staticRenderFns } from "./QuoteDocuments.vue?vue&type=template&id=6e232349"
import script from "./QuoteDocuments.vue?vue&type=script&lang=js"
export * from "./QuoteDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e232349')) {
      api.createRecord('6e232349', component.options)
    } else {
      api.reload('6e232349', component.options)
    }
    module.hot.accept("./QuoteDocuments.vue?vue&type=template&id=6e232349", function () {
      api.rerender('6e232349', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteDocuments.vue"
export default component.exports